import { api } from "./api";

export async function fetchNotificaciones(limite = 30) {
  const { data } = await api.get("/notificaciones", { params: { limite } });
  return data; // { items, no_leidas }
}

export async function fetchContadorNoti() {
  const { data } = await api.get("/notificaciones/contador");
  return data.no_leidas || 0;
}

export async function marcarNotiLeidas() {
  await api.post("/notificaciones/marcar-leidas");
}
